import { useCallback } from 'react';
import { Box, Chip, Stack, Divider } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

const prjTyps = [
  { id: 0, value: '', label: '전체', color: 'warning' },
  { id: 1, value: 'N', label: '프로젝트', color: 'info' },
  { id: 2, value: 'M', label: '유지보수', color: 'success' },
  { id: 3, value: 'ETC', label: '기타매출', color: 'success' },
];

const ChanceFailStatusList = ({ filters, onFilters }) => {
  const handleFilterType = useCallback(
    (value) => {
      onFilters('searchPrjTyp', value);
    },
    [onFilters],
  );

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItem: 'center',
        m: 1,
      }}
    >
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        spacing={2}
      >
        <Box>
          {prjTyps &&
            prjTyps.map((st, index) => (
              <Chip
                sx={{ mr: 2 }}
                key={index}
                icon={<CircleIcon />}
                label={st.label}
                variant={
                  st.value === filters.searchPrjTyp ? 'contained' : 'outlined'
                }
                color={st.color}
                onClick={() => handleFilterType(st.value)}
              />
            ))}
        </Box>
      </Stack>
    </Box>
  );
};

export default ChanceFailStatusList;
